import { render } from "./AppHand.vue?vue&type=template&id=b3fad1c4&scoped=true"
import script from "./AppHand.vue?vue&type=script&lang=js"
export * from "./AppHand.vue?vue&type=script&lang=js"

import "./AppHand.vue?vue&type=style&index=0&id=b3fad1c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fad1c4"]])

export default __exports__